// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { PatientWeightModel } from '../_models/patient-weight.model';

export enum PatientWeightActionTypes {
  PatientWeightOnServerCreated = '[Edit Patient Weight Dialog] Patient Weight On Server Created',
  PatientWeightCreated = '[Edit Patient Weight Dialog] Patient Weight Created',
  PatientWeightOnServerUpdated = '[Edit Patient Weight Dialog] Patient Weight On Server Updated',
  PatientWeightUpdated = '[Edit Patient Weight Dialog] Patient Weight Updated',
  PatientWeightStatusOnServerUpdated = '[Patient Weight List Page] Patient Weight Status On Server Updated',
  PatientWeightStatusUpdated = '[Patient Weight List Page] Patient Weight Status Updated',
  PatientWeightsStatusOnServerUpdated = '[Patient Weight List Page] Patient Weights Status On Server Updated',
  PatientWeightsStatusUpdated = '[Patient Weight List Page] Patient Weights Status Updated',
  OnePatientWeightOnServerDeleted = '[Patient Weights List Page] One Patient Weight On Server Deleted',
  OnePatientWeightDeleted = '[Patient Weights List Page] One Patient Weight Deleted',
  ManyPatientWeightsOnServerDeleted = '[Patients List Page] Many Patients On Server Deleted',
  ManyPatientWeightsDeleted = '[Patients List Page] Many Patients Deleted',
  PatientWeightsPageRequested = '[Patient Weights List Page] Patient Weights Page Requested',
  PatientWeightsPageLoaded = '[Patient Weights API] Patient Weights Page Loaded',
  PatientWeightsPageCancelled = '[Patient Weights API] Patient Weights Page Cancelled',
  PatientWeightsPageToggleLoading = '[Patient Weights] Patient Weights Page Toggle Loading',
  PatientWeightActionToggleLoading = '[Patient Weights] Patient Weights Action Toggle Loading',
  ThrowPatientWeightError = '[Patient Weights] Throw Patient Weight Error',
  ClearPatientWeightErrors = '[Patient Weights] Clear Patient Weight Errors',
}

export class PatientWeightOnServerCreated implements Action {
  readonly type = PatientWeightActionTypes.PatientWeightOnServerCreated;
  constructor(public payload: { patientWeight: PatientWeightModel; id: number }) {}
}

export class PatientWeightCreated implements Action {
  readonly type = PatientWeightActionTypes.PatientWeightCreated;

  constructor(public payload: { patientWeight: PatientWeightModel }) {}
}

export class PatientWeightOnServerUpdated implements Action {
  readonly type = PatientWeightActionTypes.PatientWeightOnServerUpdated;

  constructor(
    public payload: {
      partialPatientWeight: Update<PatientWeightModel>; // For State update
      patientWeight: PatientWeightModel; // For Server update (through service)
    },
  ) {}
}

export class PatientWeightUpdated implements Action {
  readonly type = PatientWeightActionTypes.PatientWeightUpdated;

  constructor(
    public payload: {
      partialPatientWeight: Update<PatientWeightModel>; // For State update
      patientWeight: PatientWeightModel; // For Server update (through service)
    },
  ) {}
}

export class PatientWeightStatusOnServerUpdated implements Action {
  readonly type = PatientWeightActionTypes.PatientWeightStatusOnServerUpdated;

  constructor(
    public payload: {
      patientWeight: PatientWeightModel;
      id: number;
      is_active: boolean;
    },
  ) {}
}

export class PatientWeightStatusUpdated implements Action {
  readonly type = PatientWeightActionTypes.PatientWeightStatusUpdated;

  constructor(
    public payload: {
      patientWeight: PatientWeightModel;
      id: number;
      is_active: boolean;
    },
  ) {}
}

export class PatientWeightsStatusOnServerUpdated implements Action {
  readonly type = PatientWeightActionTypes.PatientWeightsStatusOnServerUpdated;

  constructor(
    public payload: {
      patientWeights: PatientWeightModel[];
      ids: number[];
      is_active: boolean;
    },
  ) {}
}

export class PatientWeightsStatusUpdated implements Action {
  readonly type = PatientWeightActionTypes.PatientWeightsStatusUpdated;

  constructor(
    public payload: {
      patientWeights: PatientWeightModel[];
      ids: number[];
      is_active: boolean;
    },
  ) {}
}

export class OnePatientWeightOnServerDeleted implements Action {
  readonly type = PatientWeightActionTypes.OnePatientWeightOnServerDeleted;

  constructor(public payload: { id: number }) {}
}

export class OnePatientWeightDeleted implements Action {
  readonly type = PatientWeightActionTypes.OnePatientWeightDeleted;

  constructor(public payload: { id: number }) {}
}

export class ManyPatientWeightsOnServerDeleted implements Action {
  readonly type = PatientWeightActionTypes.ManyPatientWeightsOnServerDeleted;

  constructor(public payload: { ids: number[] }) {}
}

export class ManyPatientWeightsDeleted implements Action {
  readonly type = PatientWeightActionTypes.ManyPatientWeightsDeleted;

  constructor(public payload: { ids: number[] }) {}
}

export class PatientWeightsPageRequested implements Action {
  readonly type = PatientWeightActionTypes.PatientWeightsPageRequested;

  constructor(public payload: { page: QueryParamsModel; id: number }) {}
}

export class PatientWeightsPageLoaded implements Action {
  readonly type = PatientWeightActionTypes.PatientWeightsPageLoaded;

  constructor(
    public payload: {
      patientWeights: PatientWeightModel[];
      totalCount: number;
      page: QueryParamsModel;
    },
  ) {}
}

export class PatientWeightsPageCancelled implements Action {
  readonly type = PatientWeightActionTypes.PatientWeightsPageCancelled;
}

export class PatientWeightsPageToggleLoading implements Action {
  readonly type = PatientWeightActionTypes.PatientWeightsPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class PatientWeightActionToggleLoading implements Action {
  readonly type = PatientWeightActionTypes.PatientWeightActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ThrowPatientWeightError implements Action {
  readonly type = PatientWeightActionTypes.ThrowPatientWeightError;

  constructor(public payload: { error: any }) {}
}

export class ClearPatientWeightErrors implements Action {
  readonly type = PatientWeightActionTypes.ClearPatientWeightErrors;
}

export type PatientWeightActions =
  | PatientWeightOnServerCreated
  | PatientWeightCreated
  | PatientWeightOnServerUpdated
  | PatientWeightUpdated
  | PatientWeightStatusOnServerUpdated
  | PatientWeightStatusUpdated
  | PatientWeightsStatusOnServerUpdated
  | PatientWeightsStatusUpdated
  | OnePatientWeightOnServerDeleted
  | OnePatientWeightDeleted
  | ManyPatientWeightsOnServerDeleted
  | ManyPatientWeightsDeleted
  | PatientWeightsPageRequested
  | PatientWeightsPageLoaded
  | PatientWeightsPageCancelled
  | PatientWeightsPageToggleLoading
  | PatientWeightActionToggleLoading
  | ThrowPatientWeightError
  | ClearPatientWeightErrors;
